import React from "react";
import { Navigate } from "react-router-dom";
import { userLoggedIn } from "../../utils/login";

export function RequireAuth({ children }: any) {
    const isLoggedIn = userLoggedIn()
    if (isLoggedIn) {
        return children;
    }
    return <Navigate to="/" replace />;
}
